module.exports = __webpack_public_path__ + "img/flagged.ba70851b.svg";